import { type FirebaseApp, initializeApp } from 'firebase/app';
import { config } from './config.js';

let app: FirebaseApp;

export const getApp = () => {
    if (!app) {
        app = initializeApp(config);
    }
    return app;
};
